export const LOGIN_SUPPORT_URL_INCYDR = 'https://www.code42.com/r/support/con-2fa-auth-code-prompt';
